<template>

	<router-view/>

</template>

<script>
export default {

	name: 'CompanyModuleDefaultView',

}
</script>
